import Vue from "vue";
import Vuex from "vuex";
import createPersistedState from "vuex-persistedstate";

import app from "./app";
import auth from "./auth";
import market from "./market";
import basis, { plugins as basisPlugins } from "basis/store";
import hfox, { plugins as hfoxPlugins } from "hfox/store";
import defi, { plugins as defiPlugins } from "defi/store";
import trade, { plugins as tradePlugins } from "trade/store";
import wallet, { plugins as walletPlugins } from "wallet/store";

Vue.use(Vuex);

export default new Vuex.Store({
  actions: {
    initAccountData(context) {
      this.$common.utils.app.initAccountData(context);
    },
    removeAcountData(context) {
      this.$common.utils.app.removeAccountData(context);
    },
    removeMixinBindData(context) {
      this.$common.utils.app.removeMixinBindData(context);
    }
  },
  modules: {
    app,
    auth,
    market,
    basis,
    hfox,
    defi,
    trade,
    wallet
  },
  plugins: [
    createPersistedState({
      key: "app",
      paths: [
        "app.bottomNav",
        "app.settings",
        "app.config",
        "app.inited",
        "app.legalRiskState"
      ]
    }),
    createPersistedState({
      key: "auth",
      paths: ["auth"]
    }),
    createPersistedState({
      key: "market",
      paths: ["market.rateMap"]
    }),
    ...basisPlugins,
    ...hfoxPlugins,
    ...defiPlugins,
    ...tradePlugins,
    ...walletPlugins
  ]
});
